import React from "react";
import { Box, Collapse } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { useOcIsMobile } from "oc/hooks/use-is-mobile";

interface MyTimesheetFilterBodyProps {
  open: boolean;
  children: React.ReactNode;
  type: string;
  width?: string;
  noBorder?: boolean;
}

export const MyTimesheetFilterBody: React.FC<MyTimesheetFilterBodyProps> = ({
  open,
  children,
  type,
  width,
  noBorder,
}) => {
  const isMobile = useOcIsMobile();

  const theme = useTheme();
  if (!children) {
    return null;
  }

  const element = document.getElementById(`filter-item-${type}`);
  const marginLeft = element ? element.getBoundingClientRect().left - 328 : 0;

  const backgroundColor =
    type === "contract" ? theme.palette.gray20.main : theme.palette.gray30.main;
  return (
    <Box
      style={{
        backgroundColor: backgroundColor,
        borderRadius: "4px",
        border: noBorder
          ? ""
          : open
            ? `1px solid ${theme.palette.gray40.main}`
            : "none",
        marginLeft: isMobile ? "0px" : `${marginLeft}px`,
        width: isMobile ? "auto" : width || "340px",
      }}
    >
      <Collapse in={open} timeout={150}>
        {children}
      </Collapse>
    </Box>
  );
};

export default MyTimesheetFilterBody;
